/** @format */

import { Link, useLocation } from 'react-router-dom';

import { useAuth } from '../Hooks/Auth';
import { useRole } from '../Hooks/Role';

// import { useRole } from '../../Shared/hooks/CustomHooks';

const Sidebar = () => {
  const { pathname } = useLocation();
  const { can, canBoard } = useRole();
  const { check } = useAuth();
  // const { can, canBoard } = useRole();

  const activeMenu = (menu) => {
    let menus = {
      Dashboard: '/dashboard',
      Age: '/age',
      AgeCreate: '/age/create',
      Sport: '/sport',
      SportCreate: '/sport/create',
      Weight: '/weight',
      WeightCreate: '/weight/create',
      Gym: '/gym',
      GymCreate: '/gym/create',
      Level: '/level',
      LevelCreate: '/level/create',
      Agent: '/agent',
      AgentCreate: '/agent/create',
      Competition: '/competition',
      CompetitionCreate: '/competition/create',
      IDCard: '/id-card',
      IDCardCreate: '/id-card/create',
      User: '/user',
      SportRule: '/sport-rule',
      SportRuleRank: '/sport-rule/rank/print',
      SportRuleCreate: '/sport-rule/create',
      Log: '/log',
    };

    return pathname === menus[menu];
  };

  const openSubMenu = (id) => {
    let subMenu = document.getElementById(id);
    let subMenuTags = document.getElementsByClassName('sub-menu');

    if (subMenu.classList.contains('d-none')) {
      Array.from(subMenuTags).forEach((el) => {
        el.classList.remove('d-flex');
        el.classList.add('d-none');
      });
      subMenu.classList.remove('d-none');
      subMenu.classList.add('d-flex');
    } else {
      subMenu.classList.remove('d-flex');
      subMenu.classList.add('d-none');
    }
  };

  return (
    <aside className='w-100 rounded-1 overflow-hidden mt-1 p-2 py-2 bg-sky-light shadow-sm rounded-1'>
      <div className='sidebar-header text-left'>
        <h1 className='text-dark f-14 font-weight-bold border-bottom border-secondary p-3 text-center'>
          سامانه مسابقات فدراسیون زورخانه ای
        </h1>
      </div>
      <ul className='d-flex flex-column nav  m-0'>
        {check() && (
          <>
            <li
              className='my-1 rounded p-2'
              style={{
                background: activeMenu('Dashboard')
                  ? 'rgb(130 151 255)'
                  : 'rgb(177 218 226)',
              }}
              onClick={() => openSubMenu('sub-menu-0')}
            >
              <Link
                to='/dashboard'
                className='text-dark f-13 d-flex flex-row justify-content-between'
              >
                داشبورد
              </Link>
            </li>
            {can('Super Admin') && (
              <li
                className='my-1 rounded p-2'
                style={{
                  background:
                    activeMenu('Age') ||
                    activeMenu('AgeCreate') ||
                    activeMenu('Sport') ||
                    activeMenu('SportCreate') ||
                    activeMenu('Weight') ||
                    activeMenu('WeightCreate') ||
                    activeMenu('Level') ||
                    activeMenu('LevelCreate') ||
                    activeMenu('Agent') ||
                    activeMenu('AgentCreate')
                      ? 'rgb(130 151 255)'
                      : 'rgb(177 218 226)',
                }}
                onClick={() => openSubMenu('sub-menu-1')}
              >
                <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                  + تعاریف پایه
                </span>
                <ul
                  className={`${
                    activeMenu('Age') ||
                    activeMenu('AgeCreate') ||
                    activeMenu('Sport') ||
                    activeMenu('SportCreate') ||
                    activeMenu('Weight') ||
                    activeMenu('WeightCreate') ||
                    activeMenu('Level') ||
                    activeMenu('LevelCreate') ||
                    activeMenu('Agent') ||
                    activeMenu('AgentCreate')
                      ? 'd-flex'
                      : 'd-none'
                  } flex-column nav sub-menu`}
                  id='sub-menu-1'
                >
                  <li className='my-1 rounded p-2 mx-2'>
                    <Link
                      to='/sport'
                      className='text-dark text-left d-flex flex-row justify-conetnt-start f-13'
                    >
                      - رشته ها
                    </Link>
                  </li>
                  <li className='text-left d-flex flex-row justify-conetnt-start border-sky p-2 mx-2'>
                    <Link to='/age' className='text-dark f-13'>
                      - رده های سنی
                    </Link>
                  </li>
                  <li className='text-left d-flex flex-row justify-conetnt-start border-sky p-2 mx-2'>
                    <Link to='/weight' className='text-dark f-13'>
                      - وزن
                    </Link>
                  </li>
                  <li className='text-left d-flex flex-row justify-conetnt-start  p-2 mx-2'>
                    <Link to='/level' className='text-dark f-13'>
                      - سطح مسابقات
                    </Link>
                  </li>
                  <li className='text-left d-flex flex-row justify-conetnt-start  p-2 mx-2'>
                    <Link to='/agent' className='text-dark f-13'>
                      - عوامل اجرایی
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </>
        )}
        <li
          className='my-1 rounded p-2'
          style={{
            background:
              activeMenu('Gym') || activeMenu('GymCreate')
                ? 'rgb(130 151 255)'
                : 'rgb(177 218 226)',
          }}
          onClick={() => openSubMenu('sub-menu-2')}
        >
          <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
            + زورخانه
          </span>
          <ul
            className={`${
              activeMenu('Gym') || activeMenu('GymCreate') ? 'd-flex' : 'd-none'
            } flex-column nav sub-menu`}
            id='sub-menu-2'
          >
            <li className='my-1 rounded p-2 mx-2'>
              <Link
                to={
                  check() &&
                  (can('Super Admin') || canBoard() || can('Gym Manager'))
                    ? '/gym'
                    : '/gym/list'
                }
                className='text-dark d-flex flex-row justify-content-start  f-13'
              >
                - لیست زورخاانه ها
              </Link>
            </li>
            <li className='p-2 mx-2'>
              <Link
                to='/gym/create'
                className='text-dark d-flex flex-row justify-content-start f-13'
              >
                - ثبت زورخاانه
              </Link>
            </li>
          </ul>
        </li>
        {check() && (
          <>
            {can('Super Admin') || canBoard() ? (
              <li
                className='p-2 my-1 rounded'
                onClick={() => openSubMenu('sub-menu-3')}
                style={{
                  background:
                    activeMenu('Competition') || activeMenu('CompetitionCreate')
                      ? 'rgb(130 151 255)'
                      : 'rgb(177 218 226)',
                }}
              >
                <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                  + مسابقات
                </span>
                <ul
                  className={`${
                    activeMenu('Competition') || activeMenu('CompetitionCreate')
                      ? 'd-flex'
                      : 'd-none'
                  } flex-column nav sub-menu`}
                  id='sub-menu-3'
                >
                  {can('Super Admin') && (
                    <>
                      <li className='my-1 rounded p-2 mx-2'>
                        <Link
                          to='/competition'
                          className='text-dark d-flex flex-row justify-content-start f-13'
                        >
                          - لیست مسابقات
                        </Link>
                      </li>
                      <li className='my-1 rounded p-2 mx-2'>
                        <Link
                          to='/competition/create'
                          className='text-dark d-flex flex-row justify-content-start f-13'
                        >
                          - افزودن مسابقه
                        </Link>
                      </li>
                    </>
                  )}
                  {can('Super Admin') || canBoard() ? (
                    <li className='my-1 rounded p-2 mx-2'>
                      <Link
                        to='/competition/competition-register'
                        className='text-dark d-flex flex-row justify-content-start f-13'
                      >
                        - لیست مسابقات من
                      </Link>
                    </li>
                  ) : null}
                </ul>
              </li>
            ) : null}

            {can('Super Admin') && (
              <>
                <li
                  className='p-2 my-1 rounded'
                  onClick={() => openSubMenu('sub-menu-4')}
                  style={{
                    background:
                      activeMenu('IDCard') || activeMenu('IDCardCreate')
                        ? 'rgb(130 151 255)'
                        : 'rgb(177 218 226)',
                  }}
                >
                  <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                    + آی دی کارت
                  </span>
                  <ul
                    className={`${
                      activeMenu('IDCard') || activeMenu('IDCardCreate')
                        ? 'd-flex'
                        : 'd-none'
                    } flex-column nav sub-menu`}
                    id='sub-menu-4'
                  >
                    <li className='my-1 rounded p-2 mx-2'>
                      <Link
                        to='/id-card'
                        className='text-dark d-flex flex-row justify-content-start f-13'
                      >
                        - لیست آی دی کارت ها
                      </Link>
                    </li>
                    <li className='my-1 rounded p-2 mx-2'>
                      <Link
                        to='/id-card/create'
                        className='text-dark d-flex flex-row justify-content-start f-13'
                      >
                        - افزودن آی دی کارت
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className='p-2 my-1'
                  onClick={() => openSubMenu('sub-menu-5')}
                  style={{
                    background: activeMenu('User')
                      ? 'rgb(130 151 255)'
                      : 'rgb(177 218 226)',
                  }}
                >
                  <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                    + کاربران
                  </span>
                  <ul
                    className={`${
                      activeMenu('User') ? 'd-flex' : 'd-none'
                    } flex-column nav sub-menu`}
                    id='sub-menu-5'
                  >
                    <li className='my-1 rounded p-2 mx-2'>
                      <Link
                        to='/user'
                        className='text-dark d-flex flex-row justify-content-start f-13'
                      >
                        - لیست کاربران
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}

            {can('Super Admin') || can('User') || canBoard() ? (
              <li
                className='p-2 my-1'
                onClick={() => openSubMenu('sub-menu-6')}
                style={{
                  background:
                    activeMenu('SportRule') ||
                    activeMenu('SportRuleCreate') ||
                    activeMenu('SportRuleRank')
                      ? 'rgb(130 151 255)'
                      : 'rgb(177 218 226)',
                }}
              >
                <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                  + حکم ها
                </span>
                <ul
                  className={`${
                    activeMenu('SportRule') ||
                    activeMenu('SportRuleCreate') ||
                    activeMenu('SportRuleRank')
                      ? 'd-flex'
                      : 'd-none'
                  } flex-column nav sub-menu`}
                  id='sub-menu-6'
                >
                  <li className='my-1 rounded p-2 mx-2'>
                    <Link
                      to='/sport-rule'
                      className='text-dark d-flex flex-row justify-content-start f-13'
                    >
                      - لیست حکم های قهرمانی کشور
                    </Link>
                  </li>
                  <li className='my-1 rounded p-2 mx-2'>
                    <Link
                      to='/sport-rule/rank/print'
                      className='text-dark d-flex flex-row justify-content-start f-13'
                    >
                      - چاپ حکم قهرمانی کشور
                    </Link>
                  </li>
                  <li className='my-1 rounded p-2 mx-2'>
                    <Link
                      to='/sport-rule/create'
                      className='text-dark d-flex flex-row justify-content-start f-13'
                    >
                      - افزودن حکم قهرمانی کشور
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}

            {can('Developer') ? (
              <li
                className='p-2 my-1'
                onClick={() => openSubMenu('sub-menu-7')}
                style={{
                  background: activeMenu('Log')
                    ? 'rgb(130 151 255)'
                    : 'rgb(177 218 226)',
                }}
              >
                <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                  + لاگ ها
                </span>
                <ul
                  className={`${
                    activeMenu('Log') ? 'd-flex' : 'd-none'
                  } flex-column nav sub-menu`}
                  id='sub-menu-7'
                >
                  <li className='my-1 rounded p-2 mx-2'>
                    <Link
                      to='/log'
                      className='text-dark d-flex flex-row justify-content-start f-13'
                    >
                      - لاگ ها
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}
          </>
        )}
      </ul>
    </aside>
  );
};

export default Sidebar;
